import { resolveThemePackDataSlug } from "./themePackCatalog";

export const themePackStorage = {
  getItem(key: string): string | null {
    try {
      if (typeof window === "undefined") {
        return null;
      }
      const value = window.sessionStorage.getItem(key);
      if (value && key.startsWith("theme-pack-session-slug:")) {
        const timestampKey = `${key}:created-at`;
        const createdAt = window.sessionStorage.getItem(timestampKey);
        if (
          createdAt &&
          (Date.now() - Number(createdAt) >= 60 * 60 * 1000 ||
            !Number.isFinite(Number(createdAt)))
        ) {
          window.sessionStorage.removeItem(key);
          window.sessionStorage.removeItem(timestampKey);
          return null;
        }
        if (!createdAt) {
          window.sessionStorage.setItem(timestampKey, String(Date.now()));
        }
      }
      return value;
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.sessionStorage.setItem(key, value);
      if (key.startsWith("theme-pack-session-slug:")) {
        window.sessionStorage.removeItem(
          key.replace("theme-pack-session-slug:", "theme-pack-requested:"),
        );
      }
      if (key.startsWith("theme-pack-session-slug:")) {
        window.sessionStorage.setItem(`${key}:created-at`, String(Date.now()));
      }
    } catch {
      /* Storage is optional. */
    }
  },
  removeItem(key: string): void {
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      /* Storage is optional. */
    }
  },
};

export function readThemePackSession(ownerId: string): string | null {
  if (!ownerId) {
    return null;
  }
  return resolveThemePackDataSlug(
    themePackStorage.getItem(`theme-pack-session-slug:${ownerId}`),
  );
}

export function clearThemePackSessions(): void {
  try {
    Object.keys(window.sessionStorage)
      .filter((key) => key.startsWith("theme-pack-"))
      .forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    /* Storage is optional. */
  }
}

export function themePackRequestPending(
  ownerId: string,
  slug: string,
): boolean {
  return (
    readThemePackSession(ownerId) === slug &&
    themePackStorage.getItem(`theme-pack-requested:${ownerId}`) !== slug
  );
}

export function markThemePackRequested(ownerId: string, slug: string): void {
  if (readThemePackSession(ownerId) === slug) {
    themePackStorage.setItem(`theme-pack-requested:${ownerId}`, slug);
  }
}
